import { IApplicationState } from '../../../types/redux';

export function getStripContent(state: IApplicationState) {
  return state.stripBlocks;
}
